import { render } from "./FormConfirmEmail.vue?vue&type=template&id=79f38c9f&scoped=true&ts=true"
import script from "./FormConfirmEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormConfirmEmail.vue?vue&type=script&lang=ts&setup=true"

import "./FormConfirmEmail.vue?vue&type=style&index=0&id=79f38c9f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f38c9f"],['__file',"src/pages/login/components/FormConfirmEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79f38c9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79f38c9f', __exports__)) {
    api.reload('79f38c9f', __exports__)
  }
  
  module.hot.accept("./FormConfirmEmail.vue?vue&type=template&id=79f38c9f&scoped=true&ts=true", () => {
    api.rerender('79f38c9f', render)
  })

}


export default __exports__